<template>
    <b-container>
        <b-row>
            <b-col col cols="12" lg="3" md="6" class="my-1"><a href="/debtors/bunkrupt" class="main-button">Стать банкротом</a></b-col>
            <b-col col cols="12" lg="3" md="6" class="my-1"><a href="/debtors/pay" class="main-button">Оплатить онлайн</a></b-col>
            <b-col col cols="12" lg="3" md="6" class="my-1"><a href="/debtors/cancel" class="main-button">Отменить судебный приказ</a></b-col>
            <b-col col cols="12" lg="3" md="6" class="my-1"><a href="/debtors/discount" class="main-button">Погашение со скидкой</a></b-col>
            <b-col col cols="12" lg="3" md="6" class="my-1"><a href="/debtors/forget" class="main-button">Забыть про свой долг</a></b-col>
            <b-col col cols="12" lg="3" md="6" class="my-1"><a href="/debtors/certificate" class="main-button">Справка об отсутствии задолженности</a></b-col>
            <b-col col cols="12" lg="3" md="6" class="my-1"><a href="/debtors/stop" class="main-button">Перестать быть должником</a></b-col>
            <b-col col cols="12" lg="3" md="6" class="my-1"><a href="/debtors/apply" class="main-button">Обратиться за рассрочкой</a></b-col>
            <b-col col cols="12" class="my-1"><a href="/debtors/svo" class="main-button">Участникам СВО - списание долга</a></b-col>
        </b-row>
    </b-container>
</template>

<script>
export default {
  
};
</script>

<style lang="scss">

.main-button{
    align-items: center;
    justify-content: center;
    display: flex;
    text-align: center;
    background-color: #444;
    color: #fff;
    padding:10px 5px;
    width: 100%;
    height: 100%;
    border: none;
    vertical-align: middle;
    cursor: pointer;
    &:hover{
        color: #fff;
        text-decoration: none;
        background-color: $hover-color;
    }
}    
</style>